// 小程序可将登录令牌放在 H5 的普通查询参数或 Hash 路由查询参数中。
export function readEntryToken(href) {
    const url = new URL(href);
    const hashQuery = url.hash.includes('?') ? url.hash.slice(url.hash.indexOf('?') + 1) : '';
    return new URLSearchParams(hashQuery).get('accessToken') || url.searchParams.get('accessToken') || '';
}
